import request from '@/utils/request'

const url = 'admin/reservation.reservation'
/**
 * 预约记录表接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
   * 更改Reservation数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/changeStatus`,
      method: 'post',
      data
    })
  },

  /**
     * 删除Reservation
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Reservation
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 添加Reservation
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑Reservation
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },
  // 获取拼场列表
  getspellList(data) {
    return request({
      url: `${url}/getspellList`,
      method: 'post',
      data
    })
  },
  // 获取邀约列表
  getinviteList(data) {
    return request({
      url: `${url}/getinviteList`,
      method: 'post',
      data
    })
  }
}

export default api
